export default function isHttpsUrl(input: string | null | undefined) {
  try {
    const url = new URL(input || '');
    return url.protocol === 'https:';
  } catch (e) {
    return false;
  }
}
